export const PERSONAL_BROKERAGE = 'PERSONAL_BROKERAGE';
export const ROBO_PERSONAL_BROKERAGE = 'ROBO_PERSONAL_BROKERAGE';
export const TRADITIONAL_IRA = 'TRADITIONAL_IRA';
export const ROTH_IRA = 'ROTH_IRA';
export const CUSTODIAN = 'CUSTODIAN';
export const DEBIT = 'DEBIT';
export const ACCOUNT_TYPE_BANK_DDA = 'ACCOUNT_TYPE_BANK_DDA';
export const ACCOUNT_TYPE_PERSONAL_BROKERAGE = 'ACCOUNT_TYPE_PERSONAL_BROKERAGE';
export const ACCOUNT_TYPE_ROBO_PERSONAL_BROKERAGE =
	'ACCOUNT_TYPE_ROBO_PERSONAL_BROKERAGE';

export const ALLOWS_MULTIPLE_ACCOUNTS = {
	CUSTODIAN: true,
};
